import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useSelfServeContextStore } from "./SelfServeContext";
export var useSelfServeContext = function useSelfServeContext() {
  var _useSelfServeContextS = useSelfServeContextStore(["tree", "level1Node", "level2Node", "level3Node", "level4Node", "level5Node", "brandOrders", "selectedBrandOrder"]),
    _useSelfServeContextS2 = _slicedToArray(_useSelfServeContextS, 1),
    context = _useSelfServeContextS2[0];
  return {
    context: context
  };
};